export default __webpack_public_path__ + "static/media/new.7b49f041.gif";